export default "__VITE_ASSET__9beb7ed0__"